import {Mapper} from '@s-ui/domain'

export class FromStatsResponseToVOMapper extends Mapper {
  constructor({config, statsResponseValueObjectFactory}) {
    super()

    this._config = config
    this._statsResponseValueObjectFactory = statsResponseValueObjectFactory
  }

  noFormat = value => value
  integerOnly = value => Math.trunc(value)
  toFixed = value => Number(value).toFixed(2)

  map = statsResponse => {
    const statsConfig = this._config.get('search').STATISTICS_TYPES

    const adaptedStats = statsResponse.aggregations.map(({name, items}) => {
      const firstItem = items[0]

      const statisticsTypes = {
        avgPrices: {
          id: statsConfig.averagePrice,
          formatter: this.integerOnly
        },
        avgKms: {
          id: statsConfig.averageKm,
          formatter: this.integerOnly
        },
        avgYears: {
          id: statsConfig.popularYear,
          formatter: this.integerOnly
        },
        avgConsumption: {
          id: statsConfig.averageConsumption,
          formatter: this.toFixed
        },
        avgColor: {
          id: statsConfig.popularColor,
          formatter: this.noFormat
        },
        FuelType: {
          id: statsConfig.popularFuelType,
          formatter: this.noFormat
        }
      }

      return {
        id: firstItem.key, // TODO: check if this is necessary
        type: statisticsTypes[name].id,
        value: statisticsTypes[name].formatter(firstItem.value)
      }
    })

    return this._statsResponseValueObjectFactory({stats: adaptedStats})
  }
}
